import styles from './StageHeader.module.scss';

const StageHeader = ({
  title,
  primaryButton,
  secondaryButton,
  deleteButton,
}: {
  title: string;
  primaryButton?: React.ReactNode;
  secondaryButton?: React.ReactNode;
  deleteButton?: React.ReactNode;
}) => {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.title}>{title}</div>
        <div className={styles.actions}>
          {secondaryButton}
          {deleteButton}
          {primaryButton}
        </div>
      </div>
    </div>
  );
};

export default StageHeader;
